import {Component,OnDestroy,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {CertificateDtoMySuffixService} from 'src/app/client/certificate/certificateDto-my-suffix.service';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {Role} from '../../shared/model/roleType';
import {BulkDeclarationService} from './bulk-declaration.service';
import { RoleUtil } from 'src/app/shared/util/role-util';

@Component({
  selector: 'jhi-bulk-declearation-scopes',
  templateUrl: './bulk-declearation-scopes.component.html'
})
export class BulkDeclearationScopesComponent implements OnInit , OnDestroy{

  public readonly RoleUtl = RoleUtil;

  @ViewChild("markAsFavourite") markAsFavouriteModal: ModalDirective;

  scopeList = [];
  scopeObj: any;
  scopeListCopy = [];

  tempArr: any = { extenstions: [] };

  sumInsured: any;
  clientSumInsured: any;
  certificateRequestId: any;
  scopeId: any;
  certificateId: any;
  previousDeductiblesValue: number;
  isFavourite: boolean = false;

  favourite: boolean = false;

  extensions: number;
  deductibles: number;
  policyCurrney: any;

  favouriteName: any;

  scopePayLoad = {
    policyId: '',
    scopeId: '',
    scopeName: '',
    scopeDescription: '',
    additionalPremiumRate: 0,
    certificateRequestId: 0,
    certificateScopeClause: [],
    certificateScopeDeductibles: [],
    certificateScopeExtensions: [],
    insurancePremiumTaxRate: 0,
    overagePremiumRate: 0,
    premiumRate: 0,
    serviceTaxRate: 0,
    warStrikePremiumRate: 0,
    scopeTaxDtoList: []
  };

  constructor(
    private bulkDeclarationService: BulkDeclarationService,
    private certificateDtoService: CertificateDtoMySuffixService,
    private jhiAlertService: JhiAlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private stateStorageService: StateStorageService,
    public principal: Principal,
    private languageChangeService:LanguageChangeService,
  ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
   }
  ngOnInit() {
    this.checkPremiumCalculationPermission();
    this.stateStorageService.resetBulkCertificateDTO();
    this.getScopeList();
    this.favourite = JSON.parse(localStorage.getItem('favourite'));
    console.log(' ######### this.favourite ', this.favourite);
  }

  cancelMarkAsFavourite() {
    this.markAsFavouriteModal.hide();
    this.favouriteName = undefined;
  }

  confirmMarkAsFavourite() {
    this.scopeObj.certificateRequestDTO.isFavourite;
    if (this.scopeObj.certificateRequestDTO.id) {
      this.certificateDtoService.markCertificateRequestAsFavourite(this.scopeObj.certificateRequestDTO.id, this.favouriteName).subscribe(
        data => {
          if (data['message'] == 'SUCCESSFUL') {
            //  this.isFavourite = this.isFavourite == true ? false : true;
            this.isFavourite = !this.isFavourite;
            this.markAsFavouriteModal.hide();
            this.favouriteName = undefined;
          } else {
            this.favouriteName = undefined;
            this.jhiAlertService.error('Some thing went wrong');
          }
        },
        err => {
          //this.favouriteName = undefined;
          //this.markAsFavouriteModal.hide();
          this.jhiAlertService.error(err);

        }
      );
    }
  }


  makeCertificateRequestAsFavourite() {

    if (!this.isFavourite) {
      this.markAsFavouriteModal.show();
    } else {
      this.confirmMarkAsFavourite();
      //  this.isFavourite = !this.isFavourite;
    }

    // this.scopeObj.certificateRequestDTO.isFavourite;
    // if (this.scopeObj.certificateRequestDTO.id) {
    //     this.certificateDtoService.markCertificateRequestAsFavourite(this.scopeObj.certificateRequestDTO.id,this.favouriteName).subscribe(
    //         data => {
    //             if (data['message'] == 'SUCCESSFUL') {
    //                 this.isFavourite = this.isFavourite == true ? false : true;
    //             } else {
    //                 this.jhiAlertService.error('Some thing went wrong');
    //             }
    //         },
    //         err => {
    //             this.jhiAlertService.error(err);
    //         }
    //     );
    // }

  }

  getScopeList() {
    let calculatedRebateValue: number = 0;
    let finalTotal: number = 0;
    this.scopeObj = JSON.parse(localStorage.getItem('scopeList'));
    if (this.scopeObj == null || this.scopeObj.scopes == null) {
      this.router.navigateByUrl("/my-declaration/broker-get-declaration");
      return;
    }
    this.scopeList = this.scopeObj.scopes;
    this.clientSumInsured = this.scopeObj.certificateRequestDTO.cargoDetailsDTO.sumInsured;
    this.sumInsured = this.scopeObj.certificateRequestDTO.cargoDetailsDTO.sumInsuredInPolicyCurrency;
    this.certificateRequestId = this.scopeObj.certificateRequestDTO.id;
    this.policyCurrney = this.scopeObj.clientPolicyCurrency;

    for (let i = 0; i < this.scopeList.length; i++) {
      //let preRateValue = this.sumInsured * (this.scopeList[i].premiumRate / 100);
      let preRateValue = this.scopeList[i].premiumRateValue;

      let warStrikePreRateValue = this.sumInsured * (this.scopeList[i].warStrikePremiumRate / 100);

      let overagePreRateValue = this.sumInsured * (this.scopeList[i].overagePremiumRate / 100);
   
      let preSubRulePremiumValue = this.scopeList[i].preSubRulePremiumRate!=null?(this.sumInsured * this.scopeList[i].preSubRulePremiumRate )/ 100:0;
      let postSubRulePremiumValue = this.scopeList[i].postSubRulePremiumRate!=null?(this.sumInsured * this.scopeList[i].postSubRulePremiumRate )/ 100:0;


      let subTotalValue = preRateValue + warStrikePreRateValue + overagePreRateValue + preSubRulePremiumValue + postSubRulePremiumValue;


      this.scopeList[i].finalPremiumvalue = subTotalValue;

      if (this.scopeList[i].scopeTaxDtoList.length > 0) {
        let finalTax = 0;

        for (let j = 0; j < this.scopeList[i].scopeTaxDtoList.length; j++) {
          if (this.scopeList[i].scopeTaxDtoList[j].rateType === 'PERCENTAGE') {
            finalTax += this.scopeList[i].finalPremiumvalue * (this.scopeList[i].scopeTaxDtoList[j].rate / 100);
          } else if (this.scopeList[i].scopeTaxDtoList[j].rateType === 'AMOUNT') {
            finalTax += this.scopeList[i].scopeTaxDtoList[j].rate;
          }
        }

        if (this.scopeList[i].netPremiumRebate != null) {
          console.log("base prise assign", this.scopeList[i].finalPremiumvalue, "base prise", subTotalValue);
          console.log("calculated tax", finalTax);
          calculatedRebateValue = this.scopeList[i].finalPremiumvalue * (this.scopeList[i].rebatePercent / 100);
          console.log("calculated Rebate Value", calculatedRebateValue);
          if (this.scopeList[i].netPremiumRebate == true) {
            finalTotal = (this.scopeList[i].finalPremiumvalue - calculatedRebateValue) + finalTax;
            console.log("final total", finalTotal);
            this.scopeList[i].finalPremiumvalue = finalTotal.toFixed(2);
          } else {
            const rebateOnTax = finalTax * (this.scopeList[i].rebatePercent / 100);
            finalTotal = (this.scopeList[i].finalPremiumvalue - calculatedRebateValue) + (finalTax - rebateOnTax);
            this.scopeList[i].finalPremiumvalue = finalTotal.toFixed(2);
          }

        } else {
          finalTotal = this.scopeList[i].finalPremiumvalue + finalTax;
          this.scopeList[i].finalPremiumvalue = finalTotal.toFixed(2);
        }

      } else {
        // no tax
        if (this.scopeList[i].netPremiumRebate != null) {
          calculatedRebateValue = this.scopeList[i].finalPremiumvalue * (this.scopeList[i].rebatePercent / 100);
          finalTotal = (this.scopeList[i].finalPremiumvalue - calculatedRebateValue)
          this.scopeList[i].finalPremiumvalue = finalTotal.toFixed(2);
        } else {
          this.scopeList[i].finalPremiumvalue = this.scopeList[i].finalPremiumvalue.toFixed(2);
        }
      }

        //set deductable for free extesnion
        let extensions=   this.scopeList[i].certificateScopeExtensions;
        if(extensions && extensions.length >0){
        for (let j = 0 ; j< extensions.length ; j++){
            if(extensions[j].rate == 0 && extensions[j].isSelected){
                  this.addExtensionDeductables( extensions[j]  , this.scopeList[i]);
            }
        }
      }
      
    }

    this.scopeListCopy = JSON.parse(JSON.stringify(this.scopeList));
    for (let i = 0; i < this.scopeListCopy.length; i++) {
      this.scopeListCopy[i].certificateScopeExtensions = [];
      this.scopeListCopy[i].certificateScopeDeductibles = [];
    }

    for (let i = 0; i < this.scopeList.length; i++) {
      if (this.scopeList[i].certificateScopeDeductibles.length > 0) {
        this.scopeListCopy[i].certificateScopeDeductibles.push(this.scopeList[i].certificateScopeDeductibles[0]);
      }
    }

    for (let i = 0; i < this.scopeList.length; i++) {
      if (this.scopeList[i].certificateScopeExtensions.length > 0) {
        for (let j = 0; j < this.scopeList[i].certificateScopeExtensions.length; j++) {
          if (this.scopeList[i].certificateScopeExtensions[j].rateValue === 0) {
            this.scopeListCopy[i].certificateScopeExtensions.push(this.scopeList[i].certificateScopeExtensions[j]);
          }
        }
      }
    }

    console.log(this.scopeObj);
    this.jhiAlertService.success('Data successfully saved', null, null);
  }

  // calculation
 
  calculationSumInsured(scopeData) {
    let calculatedRebateValue: number = 0;
    let finalTotal: number = 0;
    this.extensions = 0;
    this.deductibles = 0;

    //let preRate = this.sumInsured * (scopeData.premiumRate / 100);
    let preRate = scopeData.premiumRateValue;

    let warStrikePreRate = this.sumInsured * (scopeData.warStrikePremiumRate / 100);

    let overagePreRate = this.sumInsured * (scopeData.overagePremiumRate / 100);

    let preSubRulePremiumValue = scopeData.preSubRulePremiumRate != null ? (this.sumInsured * scopeData.preSubRulePremiumRate) / 100 : 0;
    let postSubRulePremiumValue = scopeData.postSubRulePremiumRate!=null?(this.sumInsured * scopeData.postSubRulePremiumRate )/ 100:0;

    let subTotalValue = preRate + warStrikePreRate + overagePreRate + preSubRulePremiumValue + postSubRulePremiumValue;

    for (let i = 0; i < scopeData.certificateScopeExtensions.length; i++) {
      this.extensions += this.sumInsured * (scopeData.certificateScopeExtensions[i].rate / 100);
    }

    let scopeValue = subTotalValue + this.extensions;

    // for (let i = 0; i < scopeData.certificateScopeDeductibles.length; i++) {
    //     this.deductibles = scopeValue * (scopeData.certificateScopeDeductibles[i].rate / 100);
    // }

    let total = scopeValue;
    //let total = scopeValue - this.deductibles;

    for (let j = 0; j < this.scopeList.length; j++) {
      if (this.scopeList[j].id === scopeData.id) {
        this.scopeList[j].finalPremiumvalue = total;
        if (this.scopeList[j].scopeTaxDtoList.length > 0) {
          let finalTax = 0;
          for (let k = 0; k < this.scopeList[j].scopeTaxDtoList.length; k++) {
            if (this.scopeList[j].scopeTaxDtoList[k].rateType === 'PERCENTAGE') {
              finalTax += this.scopeList[j].finalPremiumvalue * (this.scopeList[j].scopeTaxDtoList[k].rate / 100);
            } else if (this.scopeList[j].scopeTaxDtoList[k].rateType === 'AMOUNT') {
              finalTax += this.scopeList[j].scopeTaxDtoList[k].rate;
            }
          }
          if (this.scopeList[j].netPremiumRebate != null) {
            console.log("base prise assign", this.scopeList[j].finalPremiumvalue, "base prise", subTotalValue);
            console.log("calculated tax", finalTax);
            calculatedRebateValue = this.scopeList[j].finalPremiumvalue * (this.scopeList[j].rebatePercent / 100);
            console.log("calculated Rebate Value", calculatedRebateValue);
            if (this.scopeList[j].netPremiumRebate == true) {
              finalTotal = (this.scopeList[j].finalPremiumvalue - calculatedRebateValue) + finalTax;
              console.log("final total", finalTotal);
              this.scopeList[j].finalPremiumvalue = finalTotal.toFixed(2);
            } else {
              const rebateOnTax = finalTax * (this.scopeList[j].rebatePercent / 100);
              finalTotal = (this.scopeList[j].finalPremiumvalue - calculatedRebateValue) + (finalTax - rebateOnTax);
              this.scopeList[j].finalPremiumvalue = finalTotal.toFixed(2);
            }

          } else {
            finalTotal = this.scopeList[j].finalPremiumvalue + finalTax;
            this.scopeList[j].finalPremiumvalue = finalTotal.toFixed(2);
          }

        } else {
          if (this.scopeList[j].netPremiumRebate != null) {
            calculatedRebateValue = this.scopeList[j].finalPremiumvalue * (this.scopeList[j].rebatePercent / 100);
            finalTotal = (this.scopeList[j].finalPremiumvalue - calculatedRebateValue)
            this.scopeList[j].finalPremiumvalue = finalTotal.toFixed(2);
          } else {

            this.scopeList[j].finalPremiumvalue = this.scopeList[j].finalPremiumvalue.toFixed(2);
          }
        }
      }
    }
  }

  isSelected :boolean = false;

  onCategoryExtensionsSelect(event, scope, extension: any) {
    for (let i = 0; i < this.scopeListCopy.length; i++) {
      if (event.target.checked) {
        extension.isSelected = event.target.checked;
        this.isSelected = extension.isSelected

        if (this.scopeListCopy[i].id === scope.id) {
          // this.scopeList[i].finalPremiumvalue = this.scopeList[i].finalPremiumvalue + (this.sumInsured * extension.rate / 100);

          if (this.scopeListCopy[i].certificateScopeExtensions.length === 0) {
            this.scopeListCopy[i].certificateScopeExtensions.push(extension);
            this.calculationSumInsured(this.scopeListCopy[i]);
          } else {
            let flag = false;
            for (let j = 0; j < this.scopeListCopy[i].certificateScopeExtensions.length; j++) {
              if (extension.id !== this.scopeListCopy[i].certificateScopeExtensions[j].id) {
                flag = true;
              } else {
                flag = false;
              }
            }

            if (flag) {
              this.scopeListCopy[i].certificateScopeExtensions.push(extension);
              this.calculationSumInsured(this.scopeListCopy[i]);
            }
          }

          //add deductible 
          if(extension.scopeClauseExtensionDeductableId ){
            this.addExtensionDeductables(extension,scope);
           }
        }
      } else {
        extension.isSelected = false;
        this.isSelected = extension.isSelected

        if (this.scopeListCopy[i].id === scope.id) {
          for (let k = 0; k < this.scopeListCopy[i].certificateScopeExtensions.length; k++) {
            if (this.scopeListCopy[i].certificateScopeExtensions[k].id === extension.id) {
              this.scopeListCopy[i].certificateScopeExtensions.splice(k, 1);
              // this.scopeList[i].finalPremiumvalue =
              //     this.scopeList[i].finalPremiumvalue - this.sumInsured * extension.rate / 100;
              this.calculationSumInsured(this.scopeListCopy[i]);
            }
          }
            //remove of keep deductables
            if(extension.scopeClauseExtensionDeductableId ){
              let  extensionDeductableMap = this.scopeListextensionDeductableMap.get(scope.id);
              if(extensionDeductableMap.has(extension.scopeClauseExtensionDeductableId )){
                  let value = extensionDeductableMap.get(extension.scopeClauseExtensionDeductableId);
                  
                  if(value == 1){
                  // let lengthOfDeductibles =   scope.certificateScopeDeductibles.length
                     
                   //let array = [];
                   
                   
                   //   for( let e = 0 ;e< lengthOfDeductibles ; e++){
                          
                          // if(scope.certificateScopeDeductibles[e].scopeClauseExtensionDeductableId == extension.scopeClauseExtensionDeductableId ){
                               
                           let filterdAray=   scope.certificateScopeDeductibles.filter( csd => csd.scopeClauseExtensionDeductableId != extension.scopeClauseExtensionDeductableId);
                           scope.certificateScopeDeductibles = [];
                           scope.certificateScopeDeductibles =filterdAray;
                          // scope.certificateScopeDeductibles.splice(e,1);
                              
                           //}
                     // }
                      extensionDeductableMap.set(extension.scopeClauseExtensionDeductableId, 0);
                  }else if(value > 1){
                      value--;
                      extensionDeductableMap.set(extension.scopeClauseExtensionDeductableId, value);
                  }
              }
          }else{
              
          }
          
        }
      }
    }
  }
  scopeListextensionDeductableMap =new Map();

  addExtensionDeductables(extension ,scope ){
    let extensionDeductableMap ;
    if(this.scopeListextensionDeductableMap.has(scope.id)){
        extensionDeductableMap = this.scopeListextensionDeductableMap.get(scope.id);
    }else{
        extensionDeductableMap = new Map();
        this.scopeListextensionDeductableMap.set(scope.id ,extensionDeductableMap );
    }

    if(extension.scopeClauseExtensionDeductableId ){
        if(extensionDeductableMap.has(extension.scopeClauseExtensionDeductableId )){
        let  value =    extensionDeductableMap.get(extension.scopeClauseExtensionDeductableId);
            if(value ==0){
                for(let e = 0 ; e < extension.certificateScopeExtensionDeductiblesList.length ; e++){
                    scope.certificateScopeDeductibles.push(extension.certificateScopeExtensionDeductiblesList[e]);
                }
                extensionDeductableMap.set(extension.scopeClauseExtensionDeductableId, 1);

            }else{
                value++;
                extensionDeductableMap.set(extension.scopeClauseExtensionDeductableId, value);
            }

        }else{
            for(let e = 0 ; e < extension.certificateScopeExtensionDeductiblesList.length ; e++){
                scope.certificateScopeDeductibles.push(extension.certificateScopeExtensionDeductiblesList[e]);
            }
            extensionDeductableMap.set(extension.scopeClauseExtensionDeductableId, 1);
        }
    }
}

  onCategoryDeductiblesSelect(event, scope, extension: any) {
    // for (let i = 0; i < this.scopeList.length; i++) {
    //     if (this.scopeListCopy[i].id === scope.id) {
    //         this.scopeList[i].finalPremiumvalue =
    //             this.scopeList[i].premiumRateValue - (this.scopeList[i].premiumRateValue * extension.rate / 100);
    //     }
    // }

    for (let i = 0; i < this.scopeListCopy.length; i++) {
      if (event.target.checked) {
        if (this.scopeListCopy[i].id === scope.id) {
          this.scopeListCopy[i].certificateScopeDeductibles.length = 0;
          this.scopeListCopy[i].certificateScopeDeductibles.push(extension);
          this.calculationSumInsured(this.scopeListCopy[i]);
        }
      }
    }
  }

  // on scope submit data
  onScopeSubmit(scopeData: any) {
    console.log(scopeData);
    this.scopePayLoad.certificateRequestId = this.scopeObj.certificateRequestDTO.id;

    // assigning tax DTO to final scope DTO
    this.scopePayLoad.scopeTaxDtoList = scopeData.scopeTaxDtoList;

    // this.scopePayLoad.certificateRequestId = 12333;

    for (let i = 0; i < this.scopeListCopy.length; i++) {
      if (this.scopeListCopy[i].id === scopeData.id) {
        this.scopePayLoad.certificateScopeExtensions = this.scopeListCopy[i].certificateScopeExtensions;
       // this.scopePayLoad.certificateScopeDeductibles = this.scopeListCopy[i].certificateScopeDeductibles;
      }
    }

    this.scopePayLoad.policyId = scopeData.policyId;
    this.scopePayLoad.scopeId = scopeData.scopeId;
    this.scopePayLoad.additionalPremiumRate = scopeData.additionalPremiumRate;
    this.scopePayLoad.certificateScopeClause = scopeData.certificateScopeClause;
    this.scopePayLoad.insurancePremiumTaxRate = scopeData.insurancePremiumTaxRate;
    this.scopePayLoad.overagePremiumRate = scopeData.overagePremiumRate;
    this.scopePayLoad.premiumRate = scopeData.premiumRate;
    this.scopePayLoad.serviceTaxRate = scopeData.serviceTaxRate;
    this.scopePayLoad.warStrikePremiumRate = scopeData.warStrikePremiumRate;
    this.scopePayLoad.scopeDescription = scopeData.scopeDescription;
    this.scopePayLoad.scopeName = scopeData.scopeName;
    this.scopePayLoad.certificateScopeDeductibles = scopeData.certificateScopeDeductibles;


    this.scopePayLoad['preSubRuleId'] = scopeData.preSubRuleId;
    this.scopePayLoad['postSubRuleId'] = scopeData.postSubRuleId;
    this.scopePayLoad['preSubRulePremiumRate'] = scopeData.preSubRulePremiumRate;
    this.scopePayLoad['postSubRulePremiumRate']=scopeData.postSubRulePremiumRate;
    
    if(this.scopePayLoad.certificateScopeDeductibles.length>0) {
      this.scopePayLoad.certificateScopeExtensions=this.scopePayLoad.certificateScopeExtensions.filter((obj,index,self) => index===self.findIndex((el) => (el["id"]===obj["id"])))
  }

    console.log(this.scopePayLoad);

    if(this.scopePayLoad.certificateScopeDeductibles.length>0) {
      this.scopePayLoad.certificateScopeExtensions=this.scopePayLoad.certificateScopeExtensions.filter((obj,index,self) => index===self.findIndex((el) => (el["id"]===obj["id"])))
  }

    let url = 'api/bulk-certificate-requests/' + this.scopePayLoad.certificateRequestId + '/scopes';

    this.bulkDeclarationService.scopeCreate(url, this.scopePayLoad).subscribe(data => {
      if (CommonUtils.isSame(data.body.status,MessageConst.SUCCESS)) {
        this.scopeId = data.body.payload.id;
        this.certificateId = data.body.payload.certificateRequestDTO.id;

        if(data.body.payload.certificateRequestScopeStatus === 'VESSEL_TBA') {
          let manual_request_url = "api/bulk-certificate-manual-requests/"+this.certificateId;
          this.bulkDeclarationService.getById(manual_request_url).subscribe(res => {
              if(res.failedRules === 0) {
                  this.router.navigate(['my-declaration/summary-Details/', this.certificateId, this.scopeId, false,false]);
              } else {
                  this.router.navigateByUrl('/my-declaration/no-rules');
              }
          });
      } else if (data.body.payload.certificateRequestScopeStatus === 'PENDING_CERTIFICATE_CONFIRMATION') {
          this.router.navigate(['my-declaration/summary-Details/', this.certificateId, this.scopeId, false,false]);
        } else if (data.body.payload.certificateRequestScopeStatus === 'PENDING_MANUAL_APPROVAL') {
          this.principal.identity(true).then(account => {
            // based on Role will redirect to corresponding page
            if(this.authority==Role.BROKER || this.authority==Role.BROKER_STAFF){  // do not allow broker to confirm
              if(data.body.payload.editPermission){
                this.router.navigate(['my-declaration/summary-Details/', this.certificateId, this.scopeId, false,false]);
              }else{
                this.router.navigate(['my-declaration/summary-Details/', this.certificateId, this.scopeId, false,true]);
              }
            }
            else if (account.authorities[0] !== RoleUtil.Role.CLIENT && account.authorities[0] !== RoleUtil.Role.CLIENT_STAFF) {
              this.router.navigate(['my-declaration/summary-Details/', this.certificateId, this.scopeId, false,false]);
            } else {
              this.router.navigateByUrl('/my-declaration/no-rules');
            }
           
            
          });
        }
      }
      else if (data.body.status === 'SUCCESS_MANUAL') {
        this.router.navigateByUrl('/my-declaration/automatic-aprrovel');
      }
    });
  }

  blockSpecChars(event) {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode == 95) {
      return true;
    }

    if (
      (charCode >= 33 && charCode <= 47) ||
      (charCode >= 58 && charCode <= 64) ||
      (charCode >= 91 && charCode <= 96) ||
      (charCode >= 123 && charCode <= 126)
    ) {
      return false;
    } else {
      return true;
    }
  }

  trimFavouriteName(event) {

    if (this.favouriteName) {
      this.favouriteName = this.favouriteName.trim();
    }
  }

  onPaste($event) {
    return false;
  }

  downloadInvoice(fileId: string, fileName: string) {
    this.certificateDtoService.downloadFileService(fileId).subscribe(res => {
      this.createFileFromBlob(res, fileName);
    })
  }

  createFileFromBlob(pdf: Blob, fileName: string) {
    let reader = new FileReader();
    reader.addEventListener('load', () => { }, false);
    if (pdf) {
      reader.readAsArrayBuffer(pdf);
      let fileURL = URL.createObjectURL(pdf);
      const link = document.createElement('a');
      link.href = fileURL;
      if (fileName) {
        link.download = fileName;
      } else {
        link.download = "CE_file"
      }
      link.click();
      window.URL.revokeObjectURL(fileURL);
    }
  }


  get authority() {
    return this.principal.userIdentity.authorities[0];
  }

  isPremiumCalculationDisable:boolean;
    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }
ngOnDestroy(): void {
  this.jhiAlertService.clear();
}
}
